import React, { useState, useEffect } from "react";
import { connect, useDispatch } from "react-redux";

import { Col, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import HeaderMenu from "../../components/commons/menu/HeaderMenu";
import SidebarVoucher from "./SidebarVoucher";
import moment from "moment";
import localization from "moment/locale/id";
import Voucher from '../../store/actions/voucher/Index'
import CopyableText from "../../components/commons/CopyableText";



const Index = ({ loggingIn, match, location }) => {
    
    const [dataVoucher, setDataVoucher] = useState([]);
    const [showWinnerPhoto, setShowWinnerPhoto] = useState(false);
    const dispatch = useDispatch();
    const id = match?.params?.id

    const winnerPhotoUrl = dataVoucher?.foto_pemenang
        ? dataVoucher.foto_pemenang.startsWith("http")
            ? dataVoucher.foto_pemenang
            : process.env.REACT_APP_API_URL + dataVoucher.foto_pemenang
        : "";

    useEffect(() => {
        handleRefresh();
    }, []);

    const handleRefresh = () => {
        new Promise((resolve) => {
            let param = {
                id: id,
            }
            dispatch(Voucher.getDetailVoucher(param, resolve));
        })
            .then(res => {
                setDataVoucher(res?.data[0])
            })
    }

    return (
        <div className="menu-container">
        <Row>
            <Col md={3} className="sidebar-gallery-col">
              <SidebarVoucher id={id} data={dataVoucher} returnLocation={location}/>
            </Col>
            <Col md={9}>
                <div>
                    <HeaderMenu title="Detail Voucher">
                    </HeaderMenu>
                </div>
                <div className="content-container-side">
                    <div className="box-rounded space-detail-voucher">
                        <table id="table-detail-voucher">
                            <tr><th>Nama Pemenang</th><td>{dataVoucher.nama_pemenang}</td></tr>
                            <tr><th>No WhatsApp</th><td><CopyableText value={dataVoucher.no_whatsapp} label="Nomor WhatsApp" /></td></tr>
                            <tr>
                                <th>Foto Pemenang</th>
                                <td>
                                    {winnerPhotoUrl ? (
                                        <button
                                            type="button"
                                            className="winner-photo-trigger"
                                            onClick={() => setShowWinnerPhoto(true)}
                                            aria-label="Lihat foto pemenang"
                                        >
                                            <img src={winnerPhotoUrl} alt="Foto pemenang" />
                                            <span>Lihat Foto</span>
                                        </button>
                                    ) : "-"}
                                </td>
                            </tr>
                        </table>
                    </div>
                    <div className="box-rounded space-detail-voucher">
                        <table id="table-detail-voucher">
                            <tr><th>Tanggal Klaim Voucher</th><td>{dataVoucher.tanggal_klaim ? moment(dataVoucher.tanggal_klaim).locale("id", localization).format("L") + ', ' + moment(dataVoucher.tanggal_klaim).locale("id", localization).format("LT") : "-"}</td></tr>
                        </table>
                    </div>
                </div>
            </Col>
        </Row>
        <Modal
            isOpen={showWinnerPhoto}
            toggle={() => setShowWinnerPhoto(false)}
            centered
            size="lg"
            className="winner-photo-modal"
        >
            <ModalHeader toggle={() => setShowWinnerPhoto(false)}>
                Foto Pemenang
            </ModalHeader>
            <ModalBody>
                <img src={winnerPhotoUrl} alt="Foto pemenang ukuran penuh" />
            </ModalBody>
        </Modal>
        </div>
    );
};

export default Index;

